import styled, { css } from "styled-components";

export var Container = styled.div`
    display: flex;
    align-items: center;
    height: 36px;
    padding: 0 4px;
    background: #fff;
    border: 1px solid #e8e8e8;
    border-radius: 6px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
    transition: all 0.2s ease;
    gap: 2px;

    &:hover {
        border-color: #1890ff;
        box-shadow: 0 2px 6px rgba(24, 144, 255, 0.1);
    }
`;

export var DateButton = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    color: #8c8c8c;
    cursor: pointer;
    border-radius: 4px;
    transition: all 0.15s ease;
    user-select: none;

    &:hover {
        background: #f0f5ff;
        color: #1890ff;
    }

    &:active {
        background: #e6f7ff;
        transform: scale(0.95);
    }

    .anticon {
        font-size: 12px;
        font-weight: 600;
    }
`;

export var InputWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: ${function(props) { return props.isDaily ? '190px' : '150px'; }};
    height: 28px;
    padding: 0 8px;
    border-radius: 4px;
    transition: all 0.15s ease;

    &:hover {
        background: #fafafa;
    }

    .ant-calendar-picker {
        width: 100% !important;

        > div {
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
            height: 28px !important;
        }

        .ant-calendar-picker-input {
            border: none !important;
            box-shadow: none !important;
            padding: 0 !important;
            background: transparent !important;
            cursor: pointer !important;
            height: 28px !important;
            width: 100% !important;
            text-align: center !important;

            input {
                text-align: center !important;
                font-weight: 600 !important;
                color: #262626 !important;
                font-size: 14px !important;
                cursor: pointer !important;
                padding: 0 !important;
                border: none !important;
                background: transparent !important;
                width: 100% !important;
                height: 28px !important;
                line-height: 28px !important;
                text-transform: capitalize !important;
                letter-spacing: 0.01em !important;

                &:hover {
                    color: #1890ff !important;
                }

                &:focus {
                    outline: none !important;
                    box-shadow: none !important;
                }
            }
        }

        .ant-calendar-picker-icon,
        .ant-calendar-picker-clear {
            display: none !important;
        }
    }
`;

export var ModeToggle = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    color: #1890ff;
    cursor: pointer;
    border-radius: 4px;
    margin-left: 2px;
    border-left: 1px solid #f0f0f0;
    padding-left: 6px;
    transition: all 0.15s ease;

    &:hover {
        background: #e6f7ff;
        color: #40a9ff;
    }

    &:active {
        background: #bae7ff;
        transform: scale(0.95);
    }

    .anticon {
        font-size: 14px;
    }
`;

export var TodayButton = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 28px;
    padding: 0 10px;
    color: #1890ff;
    cursor: pointer;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;
    margin-left: 2px;
    border-left: 1px solid #f0f0f0;
    padding-left: 10px;
    transition: all 0.15s ease;
    white-space: nowrap;

    &:hover {
        background: #e6f7ff;
        color: #40a9ff;
    }

    &:active {
        background: #bae7ff;
    }

    ${function(props) {
        if (props.isActive) {
            return css`
                background: #1890ff;
                color: #fff;

                &:hover {
                    background: #40a9ff;
                    color: #fff;
                }
            `;
        }
        return '';
    }}
`;

export var Divider = styled.div`
    width: 1px;
    height: 20px;
    background: #f0f0f0;
    margin: 0 4px;
`;
